import React, { Component } from 'react'
import { toQueryString } from '../../utils/commonUtils';
import IncidentService from '../../services/IncidentService';
import WithRoutify from '../../hoc/WithRoutify';
import TableSkeleton from '../../hoc/TableSkeleton';
import FormInputs from '../../components/UI/FormInputs';
import Buttons from '../../components/UI/Buttons';
import TableGrid from '../../components/UI/TableGrid';
import AddIncidentModal from '../EmployeeVisitContainer/AddIncidentModal';
import PERMISSIONS from '../../utils/AclPermissions';
import GlobalSearch from '../../components/Layouts/NewAppLayout/GlobalSearch/GlobalSearch';
import withReduxState from '../../hoc/wReduxState';
import DropDownService from '../../services/DropDownService';
import { Modal } from 'react-bootstrap';
import EmrVisitsService from '../../services/EmrVisitsService';
import OrganizationService from '../../services/OrganizationService';
import ReferralProviderService from '../../services/ReferralProviderService';
import { OK } from '../../utils/constant';


class IncidentList extends Component {
      constructor(props) {
    super(props);
     const tableHeaders = [
      {
        label: "",
        key: "isActive",
        type: "checkBox",
        changeHandler: this.checkBoxchangeHandler,
      },
      {
        label: "Snap Case Number",
        key: "snap_case_number",
        type: "",
        inputType: "TextInput",
        sortName: "snap_case_number",
      },
     {
        label: "Employer Name",
        key: "employer_name",
        type: "",
        inputType: "TextInput",
        sortName: "employer_name",
      },
        {
        label: "Employer Phone",
        key: "employer_phone",
        type: "",
        inputType: "TextInput",
        sortName: "employer_phone",
      },
       {
        label: "Patient Name",
        key: "employee_name",
        type: "",
        inputType: "TextInput",
        sortName: "employee_name",
      },
      {
        label: "Injury Date",
        key: "date_of_incident",
        type: "",
        inputType: "TextInput",
        sortName: "date_of_incident",
      },
       {
        label: "Claim Number",
        key: "claim_number",
        type: "",
        inputType: "TextInput",
        sortName: "claim_number",
      },
 
     { label: "Action", key: "action", type: "Actions" },
    ]
    // Initialize state or bind methods if needed
    this.state={
        companyList:[],
        showIncident:false,
        showReferralModal: false,
        showClaimNumberModal: false,
        selectedIncident: null,
        referrals: [],
        isLoadingReferrals: false,
        claimNumber: '',
        isSavingClaimNumber: false,
        activeStatusFilter: "",
        statusCounts: {
                total: 0,
                pendingReview: 0,
                pendingClaimNumber: 0,
                resolved: 0,
                open: 0,
                discharged: 0
            },
        filters:{

        },
         tableRecords: {
        tableHeaders: tableHeaders,
        tableRows: {
          status: 1000,
          data: [],
        },
        pagination: {
          page: 1,
          perPage: 25,
          totalRecords: 0,
          sort_by: "date_of_incident",
          sort_order: "asc",
          search: {},
        },
      },
       Tabs: [
                { label: "Open", isActive: true, name: "open" },
                { label: "Discharged", isActive: false, name: "discharged" },
          ],


    }
      }
    componentDidMount() {
        // let userProfile
        this.fetchCompanyList() 
        this.fetchList();
    }
    // 2. Add Lifecycle method to listen to Redux changes
    componentDidUpdate(prevProps, prevState) {
        // Check if the 'Incident' key in the global filter store has changed
        if (prevProps.globalFilter.Incident !== this.props?.globalFilter?.Incident) {
            this.fetchList();
        }
    }

    fetchCompanyList=async()=>{
          try{
            let companyListResponse = await DropDownService.getCompanies(null);
            let companyListOptions = [{ label: "-Select Company", value: "" }];
            companyListResponse &&
              companyListResponse?.forEach((company, companyInd) => {
                companyListOptions.push({
                  label: company.name,
                  value: company.company_uuid,
                });
              });
            this.setState({ companyList: companyListOptions },()=>this.fetchList());
          }catch(err){
    
          }
        }
       findCompanyName=(id)=>{
        
          const obj= this.state.companyList.find((val)=>val.value===id)
          if(obj){
            return obj.label
          }else{
            return ""
          }
       } 
        setActiveTab = (val) => {
    let { Tabs } = this.state;
    const { label } = val;

    let updatedTab = Tabs.map((item) => {
        if (item.label === label) {
            item.isActive = true;
        } else {
            item.isActive = false;
        }
        return item;
    });

    this.setState({
        Tabs: updatedTab,
        activeStatusFilter: "",
        tableRecords: {
            ...this.state.tableRecords,
            pagination: {
                ...this.state.tableRecords.pagination,
                page: 1 // Reset to page 1 on tab switch
            }
        }
    }, () => {
        // Directly fetch list, which will grab the new active tab
        this.fetchList(); 
    });
};
    fetchList = async (query = {}) => {
        const { tableRecords,filters,activeStatusFilter,Tabs } = this.state;
        const activeTab = Tabs.find(tab => tab.isActive);
        console.log("activetab",activeTab)
        const tabStatus = activeTab ? activeTab.name : "Open";
        try {
          // 3. Merge Global Search Data from Redux
            const globalFilter = this.props?.globalFilter?.Incident || {};
            console.log("globallllllll",globalFilter)
          // Get employee/patient ID from props if this is being used as an employee-specific view
            const { params } = this.props;
            const employeeId = params?.patientId || this.props.employeeId;
          // Combine local pagination/query with Global Filter
            const finalQuery = {
                ...tableRecords.pagination,
                ...query,
               search: {
                    ...(tableRecords.pagination.search || {}), // Keep existing pagination search
                    ...(query.search || {}),                   // Keep existing query search
                    ...globalFilter,                           // Merge Global Filter HERE
                    ...(employeeId ? { employee_id: employeeId } : {}), // Add employee filter if provided
                     ...filters,
                    tab_status:tabStatus,
                    dashboard_filter: activeStatusFilter
                } 
            };
            const queryString = toQueryString(finalQuery);
            console.log("Queryyuyu",queryString)
          this.props.Loader(true);
          const response = await IncidentService.getIncidentList(queryString);
          console.log("response", response);
            if(response){
          const { profile } = this.props;
          const isEmployerAdmin = profile?.role === 'employer_admin' || profile?.employer_login === true;
           const counts = response.counts; 
              console.log("counts", counts);   
              const totalCalculated = (counts.open || 0) + (counts.discharged || 0);  
              const pendingReviewCount = counts.pending_review || 0;
              const pendingClaimCount = counts.pending_claim || 0;
          const tableData = response.data.data.map((incident, Index) => {
            // Employers should not be able to open incident details from the list
            const viewIncidentAcl = profile?.employer_login ? PERMISSIONS.NO_PERMISSION : PERMISSIONS.INCIDENT.EDIT;
            const actionItems = [
                {
                    className: "btn btn-icon btn-transparent-dark",
                    iconType: "Search",
                    title: "View",
                    type: "GridEdit",
                    acl: viewIncidentAcl,
                    clickHandler: (rowId, data) => this.editHandler(incident),
                },
                {
                    className: "btn btn-icon btn-transparent-dark",
                    iconType: "Remove",
                    acl: PERMISSIONS.INCIDENT.DELETE,
                    title: "Delete",
                    isDelete: true,
                    clickHandler: () => this.deleteHandler(incident.incident_id),
                },
            ];

            // Add meatball menu for employer admin
            if (isEmployerAdmin) {
              actionItems.push({
                className: "btn btn-icon btn-transparent-dark",
                iconType: "MeatBall",
                title: "More",
                acl: "any",
                iconDropDownList: [
                  {
                    className: "btn btn-icon btn-transparent-dark",
                    iconType: "Print",
                    label: "View Referral",
                    title: "View Referral",
                    acl: "any",
                    clickHandler: () => this.viewReferralHandler(incident)
                  },{
                    className: "btn btn-icon btn-transparent-dark",
                    iconType: "Print",
                    label: "View Auth",
                    title: "Compliance",
                    clickHandler: () => {}
                  },{
                    className: "btn btn-icon btn-transparent-dark",
                    iconType: "Print",
                    label: "Export List",
                    title: "Compliance",
                    clickHandler: () => {}
                  },{
                    className: "btn btn-icon btn-transparent-dark",
                    iconType: "Print",
                    label: "Add Claim Number",
                    title: "Edit Claim Number",
                    clickHandler: () => this.openClaimNumberModal(incident)
                  },
                ],
              });
            }

            return {
              companyIndex: Index,
              isHeading: false,
              rowId: incident.incident_id,
              data: {
                  isActive: false,
                  snap_case_number: incident.snap_case_number,
                  claim_number: incident.claim_number,
                  employee_name:incident.employee_name,
                  employer_name:this.findCompanyName(incident.employer_id),
                  employer_phone:incident.employer_phone,
                  date_of_incident: incident.date_of_incident,
                  action: actionItems,
              },
            };
          });
          // console.log('tableData',response?.data);
          this.setState((prevState) => ({
            statusCounts: {
            total: totalCalculated || 0, // Or use totalRecords if you prefer the filtered count
            pendingReview: pendingReviewCount|| 0,
            pendingClaimNumber: pendingClaimCount ||0, 
            open: counts.open || 0,
            discharged: counts.discharged || 0// Ensure your API sends this key
            // Ensure your API sends this key
            // resolved: counts.resolved || 0 // Ensure your API sends this key
        },
            tableRecords: {
              ...prevState.tableRecords,
              tableHeaders: prevState.tableRecords.tableHeaders,
              tableRows: {
                type: "default",
                status: 200,
                data: tableData,
              },
              pagination: {
                ...prevState.tableRecords.pagination,
                ...query,
                totalRecords: response?.data?.total,
              },
            },
          }));}
        } catch (err) {
          this.setState({
            tableRecords: {
              ...tableRecords,
              tableRows: {
                ...tableRecords.tableRows,
                status: 200,
              },
            },
          });
          console.log("DataIsse");
          // console.error("Error fetching companies:", err);
        } finally {
          this.props.Loader(false);
        }
      };
      editHandler=(data)=>{
        console.log("id",data);
        
            this.setState({visit_id:data.visit_id,showIncident:true})
      }
    onChangeFiltersHandler = (key, val) => {
        const { filters } = this.state;
        this.setState({
            filters: {
                ...filters,
                [key]: val,
            },
        });
    };
    submitFiltersHandler = async () => {
        const { filters, tableRecords } = this.state;
        const queryfilters = {
            ...tableRecords.pagination,
            page: 1,
            search: filters,
        };
        this.fetchList(queryfilters);
    };
   clearFiltersHandler = ()=>{
    this.setState({
      filters: {
        ...this.state.filters,
        search_query:'',    
      },
    },this.submitFiltersHandler);
  };
    incidentToogleHanlder=()=>{
        this.setState({showIncident:!this.state.showIncident})
        this.fetchList();
    }
    deleteHandler=async(id)=>{
         this.props.Loader(true);
        await IncidentService.deleteIncident(id)
      .then((res) => {
        this.fetchList();
        this.props.Toast.success("Incident Deleted Succesfully");
      })
      .catch((err) => {
        //
      })
      .finally(() => {
         this.props.Loader(false);
        //
      });
    }

    // Helper: Check if user is employer admin
    isEmployerAdmin = () => {
      const { profile } = this.props;
      return profile?.role === 'employer_admin' || profile?.employer_login === true;
    }

    // Helper: Extract referral object from response
    extractReferralObject = (referralData) => {
      if (Array.isArray(referralData)) return referralData[0];
      if (typeof referralData !== 'object') return null;
      
      const keys = Object.keys(referralData);
      return keys.length > 0 && !isNaN(keys[0]) ? referralData[keys[0]] : referralData;
    }

    // Helper: Format referral name from field key
    formatReferralName = (key) => {
      return key.replace('_referral', '').replace(/_/g, ' ')
        .split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    }

    // Helper: Extract referral fields and provider IDs
    extractReferrals = (referralObject) => {
      const referrals = [];
      Object.keys(referralObject).forEach(key => {
        if (key.endsWith('_referral') && referralObject[key]) {
          const providerId = referralObject[key];
          if (typeof providerId === 'string' && providerId.trim()) {
            referrals.push({
              referralName: this.formatReferralName(key),
              providerId: providerId
            });
          }
        }
      });
      return referrals;
    }

    // Helper: Fetch provider names
    fetchProviderNames = async (referrals) => {
      try {
        const response = await ReferralProviderService.getReferralProviders(null, {
          perPage: 1000,
          page: 1
        });
        
        if (!response?.data || !Array.isArray(response.data)) return {};
        
        const providersMap = {};
        response.data.forEach(provider => {
          providersMap[provider.referral_provider_id] = provider;
        });
        
        return referrals.reduce((acc, referral) => {
          const provider = providersMap[referral.providerId];
          acc[referral.providerId] = provider 
            ? `${provider.first_name || ''} ${provider.last_name || ''}`.trim() 
            : 'N/A';
          return acc;
        }, {});
      } catch (error) {
        console.error("Error fetching provider details:", error);
        return {};
      }
    }

    viewReferralHandler = async (incident) => {
      // Validate access and incident data
      if (!this.isEmployerAdmin()) {
        this.props.Toast.error("Access denied. Employer admin access required.");
        return;
      }

      if (!incident.visit_id || !incident.incident_id) {
        this.props.Toast.error(incident.visit_id ? "Incident ID not found" : "Visit ID not found for this incident");
        return;
      }

      this.setState({
        showReferralModal: true,
        selectedIncident: incident,
        referrals: [],
        isLoadingReferrals: true
      });

      try {
        const response = await EmrVisitsService.getReferralSelection(incident.visit_id);
        
        if (response?.code !== 200 || !response.data) {
          this.setState({ referrals: [], isLoadingReferrals: false });
          return;
        }

        const referralObject = this.extractReferralObject(response.data);
        if (!referralObject) {
          this.setState({ referrals: [], isLoadingReferrals: false });
          return;
        }

        const referrals = this.extractReferrals(referralObject);
        const providerNames = await this.fetchProviderNames(referrals);
        
        const parsedReferrals = referrals.map(ref => ({
          ...ref,
          providerName: providerNames[ref.providerId] || 'N/A'
        }));

        this.setState({ referrals: parsedReferrals, isLoadingReferrals: false });
      } catch (error) {
        console.error("Error fetching referrals:", error);
        this.props.Toast.error("Failed to fetch referrals for this incident");
        this.setState({ referrals: [], isLoadingReferrals: false });
      }
    }

    closeReferralModal = () => {
      this.setState({
        showReferralModal: false,
        selectedIncident: null,
        referrals: []
      });
    }

    openClaimNumberModal = (incident) => {
      this.setState({
        showClaimNumberModal: true,
        selectedIncident: incident,
        claimNumber: incident.claim_number || ''
      });
    }

    closeClaimNumberModal = () => {
      this.setState({
        showClaimNumberModal: false,
        selectedIncident: null,
        claimNumber: '',
        isSavingClaimNumber: false
      });
    }

    handleClaimNumberChange = (value) => {
      this.setState({ claimNumber: value });
    }

    saveClaimNumber = async () => {
      const { selectedIncident, claimNumber } = this.state;
      
      if (!selectedIncident || !selectedIncident.incident_id) {
        this.props.Toast.error("Incident not found");
        return;
      }

      this.setState({ isSavingClaimNumber: true });

      try {
        const response = await IncidentService.updateClaimNumber(selectedIncident.incident_id, claimNumber);

        if (response && (response.code === 200 || response.code === OK)) {
          this.props.Toast.success("Claim number updated successfully");
          this.closeClaimNumberModal();
          this.fetchList(); // Refresh the list
        } else {
          this.props.Toast.error(response?.message || "Failed to update claim number");
        }
      } catch (error) {
        console.error("Error updating claim number:", error);
        this.props.Toast.error("Failed to update claim number");
      } finally {
        this.setState({ isSavingClaimNumber: false });
      }
    }
    handleDashboardCardClick = (filterType) => {
    // If clicking the same filter again, clear it (toggle behavior)
    const newFilter = this.state.activeStatusFilter === filterType ? "" : filterType;
    this.setState({
        activeStatusFilter: newFilter,
        tableRecords: {
            ...this.state.tableRecords,
            pagination: {
                ...this.state.tableRecords.pagination,
                page: 1 
            }
        }
    }, () => {
        this.fetchList();
    });
};
    
  render() {
    const { tableRecords, filters, showIncident,visit_id,employeeDetails,activeEditId ,selectedBodyPart,Tabs} = this.state;
    const activeTab = Tabs.find(tab => tab.isActive);
    const tabStatus = activeTab ? activeTab.name : "open";
     const globalSearchFilter = [
      "/visits",
      "/appointments",
      "/white-board",
      "/labs",
      "/result/vaccine",
      "/result/physical-drug-screens",
      "/employee",
      "/incident"
    ];
    const { profile, location, isNewUI, params } = this.props;
    const { pathname } = location;
     //   const STATUS_KEYS = {
  //   TOTAL: "",
  //   PENDING: "Pending",
  //   AWAITING: "Awaiting Employer Response",
  //   RESOLVED: "Resolved"
  // };
          const getCardClass = (filter) => {
    return this.state.activeStatusFilter === filter ? "sh_statusIndicatorbox_active" : "";
};
    // Check if this is being used as an employee-specific view
    const isEmployeeView = params?.patientId || this.props.employeeId;

    const { showReferralModal, showClaimNumberModal, selectedIncident, referrals, isLoadingReferrals } = this.state;

    return (
        <>
        {showIncident &&
            <AddIncidentModal incidentToogleHandler={this.incidentToogleHanlder} isOpen={showIncident} visitId={visit_id} employeeDetails={employeeDetails} isEdit={true} isFromIncidentList={true} selectedBodyPart={selectedBodyPart}  setSelectedBodyPart={(val) => this.setState({ selectedBodyPart: val })}/>
        }
        {showClaimNumberModal && (
          <Modal show={showClaimNumberModal} onHide={this.closeClaimNumberModal}>
            <Modal.Header closeButton>
              <Modal.Title>Edit Claim Number</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="form-group">
                <label>Claim Number</label>
                <FormInputs
                  type="TextInput"
                  value={this.state.claimNumber}
                  changeHandler={this.handleClaimNumberChange}
                  className="form-control"
                  placeholder="Enter claim number"
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Buttons
                className="btn btn-secondary"
                clickHandler={this.closeClaimNumberModal}
                label="Cancel"
                disabled={this.state.isSavingClaimNumber}
              />
              <Buttons
                className="btn btn-primary"
                clickHandler={this.saveClaimNumber}
                label={this.state.isSavingClaimNumber ? "Saving..." : "Save"}
                disabled={this.state.isSavingClaimNumber}
              />
            </Modal.Footer>
          </Modal>
        )}
        {showReferralModal && (
          <Modal show={showReferralModal} onHide={this.closeReferralModal} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>
                Referrals for Incident: {selectedIncident?.snap_case_number || selectedIncident?.claim_number || 'N/A'}
                {selectedIncident?.claim_number && selectedIncident?.snap_case_number && (
                  <span className="text-muted"> ({selectedIncident.claim_number})</span>
                )}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {isLoadingReferrals ? (
                <div className="text-center p-4">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              ) : referrals.length === 0 ? (
                <div className="text-center p-4">
                  <p>No referrals found for this incident.</p>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Referral Name</th>
                        <th>Provider Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {referrals.length === 0 ? (
                        <tr>
                          <td colSpan="2" className="text-center">No referrals found</td>
                        </tr>
                      ) : (
                        referrals.map((referral, index) => (
                          <tr key={index}>
                            <td>{referral.referralName || 'N/A'}</td>
                            <td>{referral.providerName || 'N/A'}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Buttons
                className="btn btn-secondary"
                clickHandler={this.closeReferralModal}
                label="Close"
              />
            </Modal.Footer>
          </Modal>
        )}
        <TableSkeleton
          tableRecords={tableRecords}
          customSkelton={true}
          addFormHandler={()=>{}}
          acl={"any"}
          content={"Incident"}
        >
        
            {/* {!isEmployeeView && (
            <div className="sh_cardHeader pb-0">
              <div className="d-flex flex-column">
              <div className="d-flex position-relative">
                  <h2 className="h2-strong position-absolute sh_welcome-text ">Incident List</h2>
                  {isNewUI && 
                        profile &&
                        profile.is_multiple_organization === false &&
                        profile.employee_login === false &&
                        globalSearchFilter.some((path) => pathname.startsWith(path)) && (
                        <GlobalSearch
                            activeMenu={"Incident"}
                            pathname={pathname}
                        />
                    )}
                </div>
              </div>
          </div>
            )} */}
              <div className="sh_cardBox">
              {!isEmployeeView && (
            <div className="sh_cardHeader pb-0">
              <div className="d-flex flex-column">
              <div className="d-flex position-relative">
                  <h2 className="h2-strong position-absolute sh_welcome-text ">Incident List</h2>
                  {isNewUI && 
                        profile &&
                        profile.is_multiple_organization === false &&
                        profile.employee_login === false &&
                        globalSearchFilter.some((path) => pathname.startsWith(path)) && (
                        <GlobalSearch
                            activeMenu={"Incident"}
                            pathname={pathname}
                        />
                    )}
                </div>
              </div>
          </div>
          )}
            {/* --- A. Header with Tabs (Left) and Search/Buttons (Right) --- */}
            <div className="sh_cardHeader sh_cardbglight p-1">
              <div className="form-group d-flex mb-0 app-heading-tab justify-content-between align-items-center app-heading-md">
                {/* Left Side: Tabs */}
                <div className="app-header-tab">
                  <div className="tabs_wrapForTable pr-2">
                    <ul className="nav nav-borders nav-tabs border-0" role="tablist">
                      {Tabs.map((itm, itmInd) => {
                        return (
                          <li key={itmInd}>
                            <a
                              className={`flex-sm-fill text-sm-center nav-link ${itm.isActive ? "active" : ""}`}
                              aria-current="page"
                              onClick={() => this.setActiveTab(itm)}
                              style={{cursor:"pointer"}}
                            >
                              {itm.label}
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>

                {/* Right Side: Search & Buttons */}
                <div className="d-flex ml-3 mt-1 filteropen_header">
              <div className="d-flex sh_filter_formheader">
                    {/* Search Input */}
                    <div className="d-flex p-1">
                  <div>
                        <FormInputs
                          placeholder="Incident"
                          value={filters["search_query"]}
                          changeHandler={(val) =>
                            this.onChangeFiltersHandler("search_query", val)
                          }
                          className="form-control"
                        />
                      </div>
                    </div>
                   {/* Action Buttons */}
                    <div className="d-flex">
                      <div className="addAction mr-2">
                        <div className="btn-group p-1">
                          <button
                            className="btn btn-primary"
                            onClick={() => this.submitFiltersHandler()}
                          >
                            Search
                          </button>
                          <button
                            className="btn btn-outline-secondary"
                            onClick={() => this.clearFiltersHandler()}
                          >
                            Clear
                          </button>
                        </div>
                       {/* <div className="addAction">
                    <div className="btn-group">
                      <Buttons
                        clickHandler={() => {
                          this.addFormHandler();
                          this.setState({ activeEditId: "" });
                        }}
                        className="btn btn-primary"
                        // acl={PERMISSIONS.ICD10.CREATE}
                        label={"Add"}
                      />
                    </div>
                  </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
           
             {!isEmployeeView && isNewUI && (
               <div className="sh_cardHeader sh_cardbglight  px-0">
              <div className="row">
                <div className="col-md-3 col-6">
                  <div className={`d-flex sh_statusIndicatorbox blue-orichid px-3 py-2 ${getCardClass('total')}`}
    onClick={() => this.handleDashboardCardClick('total')} style={{ cursor: "pointer" }}
>
                    <div className="d-flex align-items-center ">
                      <span className="sh_statusIndicator bg-light">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <ellipse
                            cx="12"
                            cy="5.8125"
                            rx="3.3125"
                            ry="3.3125"
                            stroke="#1D2433"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M16 21V12.4424"
                            stroke="#1D2433"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12.0001 17H9.50012C8.6717 17 8.00012 17.6716 8.00012 18.5V20C8.00012 20.5523 8.44784 21 9.00012 21H18.0002C19.1047 21 20.0002 20.1046 20.0002 19V17.3469C20.0057 15.0413 18.432 13.0317 16.1923 12.4842C13.4348 11.8386 10.5654 11.8386 7.80788 12.4842C5.56821 13.0317 3.99451 15.0413 4.00001 17.3469L4.00012 20"
                            stroke="#1D2433"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12 12V21"
                            stroke="#1D2433"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex flex-column">
                      <p className="p1-light text-dark mb-0">Total Incidents</p>
                       <h3 className="h3-strong mb-0">{this.state.statusCounts.total}</h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-6">
                  <div className={`d-flex sh_statusIndicatorbox pale-purple px-3 py-2  ${getCardClass('pending_review')}`}
    onClick={() => this.handleDashboardCardClick('pending_review')} style={{ cursor: "pointer" }}
>
                    <div className="d-flex align-items-center ">
                      <span className="sh_statusIndicator bg-light">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21 14V18C21 19.6569 19.6569 21 18 21H17"
                            stroke="#1D2433"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M3 10V6C3 4.34315 4.34315 3 6 3H9"
                            stroke="#1D2433"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M3 20L4.156 20.578C4.71109 20.8555 5.32318 21 5.94378 21H12.5C13.3284 21 14 20.3284 14 19.5V19.5C14 18.6716 13.3284 18 12.5 18H8.5"
                            stroke="#1D2433"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M3 13H5.91335C6.34609 13 6.76716 13.1404 7.11335 13.4L9.35062 15.0779C9.7271 15.3603 9.96252 15.7921 9.99588 16.2615C10.0292 16.731 9.85726 17.1917 9.5245 17.5245V17.5245C8.95325 18.0958 8.04889 18.16 7.4026 17.6753L6 16.6234"
                            stroke="#1D2433"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M19.7969 5.75H18.0469V4C18.0469 3.44772 17.5992 3 17.0469 3H15.5469C14.9946 3 14.5469 3.44772 14.5469 4V5.75H12.7969C12.2446 5.75 11.7969 6.19772 11.7969 6.75V8.25C11.7969 8.80228 12.2446 9.25 12.7969 9.25H14.5469V11C14.5469 11.5523 14.9946 12 15.5469 12H17.0469C17.5992 12 18.0469 11.5523 18.0469 11V9.25H19.7969C20.3492 9.25 20.7969 8.80228 20.7969 8.25V6.75C20.7969 6.19772 20.3492 5.75 19.7969 5.75Z"
                            stroke="#1D2433"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex flex-column">
                      <p className="p1-light text-dark mb-0">Pending Review </p>
                      <h3 className="h3-strong mb-0">{this.state.statusCounts.pendingReview}</h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-6">
                  <div className={`d-flex sh_statusIndicatorbox linear_gradient px-3 py-2 ${getCardClass('pending_claim')}`}
    onClick={() => this.handleDashboardCardClick('pending_claim')} style={{ cursor: "pointer" }}
>
                    <div className="d-flex align-items-center ">
                      <span className="sh_statusIndicator bg-light">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12"
                            cy="9.5"
                            r="2.5"
                            stroke="#1D2433"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M7.5 16C7.89691 15.0894 8.7956 14.5005 9.78894 14.5H14.2111C15.2044 14.5005 16.1031 15.0894 16.5 16"
                            stroke="#1D2433"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12 17V14.5"
                            stroke="#1D2433"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <circle
                            cx="12"
                            cy="12"
                            r="9"
                            stroke="#1D2433"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex flex-column">
                      <p className="p1-light text-dark mb-0">
                        Pending Claim Number
                        </p>
                        <h3 className="h3-strong mb-0">{this.state.statusCounts.pendingClaimNumber}</h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-6">
                  <div className={`d-flex sh_statusIndicatorbox olivegreen px-3 py-2 ${getCardClass('tab_default')}`}
    onClick={() => this.handleDashboardCardClick('tab_default')} style={{ cursor: "pointer" }}
>
                    <div className="d-flex align-items-center ">
                      <span className="sh_statusIndicator bg-light">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11 3H6C4.34315 3 3 4.34315 3 6V9"
                            stroke="#1D2433"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M17 21H18C19.6569 21 21 19.6569 21 18V13"
                            stroke="#1D2433"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <ellipse
                            cx="17"
                            cy="7"
                            rx="4"
                            ry="4"
                            stroke="#1D2433"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M18.25 6.5L16.6883 8L15.75 7.1"
                            stroke="#1D2433"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <ellipse
                            cx="8"
                            cy="13.5"
                            rx="2.5"
                            ry="2.5"
                            stroke="#1D2433"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M13 21C13 19.6193 11.8807 18.5 10.5 18.5H5.5C4.11929 18.5 3 19.6193 3 21"
                            stroke="#1D2433"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                    <div className="d-flex flex-column">
                      <p className="p1-light text-dark mb-0">{tabStatus === "open" ? "Visits Ongoing" : "Unable to bill"}</p>
                      <h3 className="h3-strong mb-0">{tabStatus === "open" 
    ? this.state.statusCounts.open 
    : this.state.statusCounts.discharged
  }</h3>
                    </div>
                  </div>
                </div>
              </div>
              </div>
              )}
            

            <div className="sh_cardBody sh_cardbglight p-0">
              <TableGrid
                addFormHandler={() => this.incidentToogleHanlder()}
                hasPagination={true}
                fetchTableRecords={(filters) => this.fetchList(filters)}
                {...tableRecords}
              />
            </div>
          </div>
       {/* </div> */}
        </TableSkeleton>
         
        </>
    )
  }
}
export default withReduxState(WithRoutify(IncidentList));